export const ORIGINS = {
  AOP: "Appellation d'Origine Protégée",
  BBC: "Bleu Blanc Coeur",
  BIO: "Bio",
  FM: "Fait Maison",
  IGP: "Indication Géographique Protégée",
  MSC: "Msc",
  LBR: "Label Rouge",
  POF: "Le Porc Français",
  SGE: "Produit Décongelé",
  VBF: "Viande Bovine Française",
  VOF: "Viande Volaille Française",
};

export const PRODUCT_TYPES = {
  STARTER: "ENT",
  MAIN: "PLA",
  DESSERT: "DES",
  CHEESE: "FRO",
};

export const PRODUCT_TYPES_NAMES = {
  [PRODUCT_TYPES.STARTER]: "Entrée",
  [PRODUCT_TYPES.MAIN]: "Plat",
  [PRODUCT_TYPES.DESSERT]: "Dessert",
  [PRODUCT_TYPES.CHEESE]: "Fromage",
};
